import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('BookingService', BookingService);

  BookingService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'BookingModalService',
    'SessionService',
    'ModalWindowConfirmService',
    'WindowModalService',
  ];

  function BookingService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    BookingModalService,
    SessionService,
    ModalWindowConfirmService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'bookings';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getBookings: getBookings,
      getBooking: getBooking,
      saveBooking: saveBooking,
      deleteBooking: deleteBooking,
      changeBookingPriceList: changeBookingPriceList,

      openSendBookingConfirmationToClient: openSendBookingConfirmationToClient,
      sendBookingConfirmationToClient: sendBookingConfirmationToClient,
      openSendBookingItineraryToClient: openSendBookingItineraryToClient,
      sendBookingItineraryToClient: sendBookingItineraryToClient,
      openSendBookingVouchersToClient: openSendBookingVouchersToClient,
      sendBookingVouchersToClient: sendBookingVouchersToClient,

      printInvoice: printInvoice,

      openBookingChangeStatus: openBookingChangeStatus,
      updateBookingStatus: updateBookingStatus,

      openBookingHistory: openBookingHistory,
      getBookingHistory: getBookingHistory,
      getReceivedPaymentDocuments: getReceivedPaymentDocuments,
      openSearchByItem: openSearchByItem,
      updateBookings: updateBookings,
      getBookingBySubdomain: getBookingBySubdomain,
      getTotalPax: getTotalPax,
      createBookingInvoice: createBookingInvoice,

      openSearchRelatedBookings: openSearchRelatedBookings,

      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
      hasRelatedTransactions: hasRelatedTransactions,

      applyDiscountCoupon: applyDiscountCoupon,
      deleteDiscountCoupon: deleteDiscountCoupon,

      openBookingInfoModal: openBookingInfoModal,
    };

    return service;

    ///////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'start_date',
      };

      return filter;
    }

    function getBookings(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              stats: response.meta.stats,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        function () {
          return {
            items: [],
            totalItems: 0,
            entryLimit: 0,
            totalPages: 0,
            stats: [],
          };
        }
      );
    }

    // get the booking detail
    function getBooking(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveBooking(params) {
      var url = apiUrl;
      var method = 'post';

      if (params.booking.id) {
        // edit
        url += '/' + params.booking.id;
        method = 'put';
      }

      function success(response) {
        if (params.booking.id) {
          // edit
          utils._successMsg($translate('BOOKING_MODIFIED'));
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      params.booking.website_id = SessionService.getSelectedAccountCompanyWebsite().id;

      return RestResource.request(method, url, params, success, failure);
    }

    function openSendBookingConfirmationToClient(booking) {
      // successCallback
      BookingModalService.openSendBookingConfirmationToClient(booking); // successCallback
    }

    function sendBookingConfirmationToClient(bookingId, companyId, clientEmail) {
      var url = apiUrl + '/' + bookingId + '/send_booking_to_client?option=booking';

      return RestResource.request(
        'get',
        url,
        { company_id: companyId, email: clientEmail },
        function (response) {
          utils._successMsg($translate('CONFIRMATION_SENT_TO_CLIENT'));

          return response.data;
        },
        function () {
          utils._errorMsg($translate('CONFIRMATION_NOT_SENT'));

          return false;
        }
      );
    }

    function openSendBookingItineraryToClient(booking) {
      // successCallback
      BookingModalService.openSendBookingItineraryToClient(booking); // successCallback
    }

    function sendBookingItineraryToClient(bookingId, companyId, clientEmail) {
      var url = apiUrl + '/' + bookingId + '/send_booking_to_client?option=itinerary';

      return RestResource.request(
        'get',
        url,
        { company_id: companyId, email: clientEmail },
        function (response) {
          utils._successMsg($translate('ITINERARY_SENT_TO_CLIENT'));

          return response.data;
        },
        function () {
          utils._errorMsg($translate('ITINERARY_NOT_SENT'));

          return false;
        }
      );
    }

    function openSendBookingVouchersToClient(booking) {
      // successCallback
      BookingModalService.openSendBookingVouchersToClient(booking); // successCallback
    }

    function sendBookingVouchersToClient(bookingId, companyId, clientEmail) {
      var url = apiUrl + '/' + bookingId + '/send_booking_to_client?option=vouchers';

      return RestResource.request(
        'get',
        url,
        { company_id: companyId, email: clientEmail },
        function (response) {
          utils._successMsg($translate('VOUCHERS_SENT_TO_CLIENT'));

          return response.data;
        },
        function () {
          utils._errorMsg($translate('VOUCHERS_NOT_SENT'));

          return false;
        }
      );
    }

    // print invoice PDF (booking)
    function printInvoice(id) {
      var url = apiUrl + '/' + id + '/get_invoice';

      return RestResource.request(
        'get',
        url,
        { from_client: true },
        function (response) {
          return response.data;
        },
        function () {}
      );
    }

    function openBookingChangeStatus(booking, successCallback) {
      BookingModalService.openBookingChangeStatus(booking, successCallback);
    }

    function updateBookingStatus(booking, status, modificationReason, params) {
      var url = apiUrl + '/' + booking.id + '?set_status=true';

      var item = {
        id: booking.id,
        status: status,
        company_id: booking.company_id,
        reason_status: null,
      };

      if (modificationReason) {
        item.reason_status = modificationReason;
      }

      if (!params) {
        params = {};
      }

      return RestResource.request(
        'put',
        url,
        { booking: item, params: params },
        function (response) {
          var msg;

          switch (status) {
            case 'processing':
              msg = 'BOOKING_MODIFIED';
              break;
            case 'confirmed':
              msg = 'BOOKING_CONFIRMED';
              break;
            case 'cancelled':
              msg = 'BOOKING_CANCELLED';
              break;
            default:
              msg = 'draft';
              break;
          }

          utils._successMsg($translate(msg));

          return response.data;
        },
        function (response) {
          return response.data;
        }
      );
    }

    // open booking history modal
    function openBookingHistory(booking) {
      BookingModalService.openBookingHistory(booking);
    }

    function getBookingHistory(id, params) {
      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/get_booking_history',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function getReceivedPaymentDocuments(id, params) {
      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/get_received_payment_documents',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    // open search by item modal
    function openSearchByItem(itemSearch, searchedProduct, successCallback, clearSearchByItem) {
      BookingModalService.openSearchByItem(
        itemSearch,
        searchedProduct,
        successCallback,
        clearSearchByItem
      );
    }

    function updateBookings(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    // Get booking, based on subdomain
    function getBookingBySubdomain(subdomain, bookingId) {
      var url =
        environment.apiEndpoint + 'bookings_client/' + bookingId + '/get_booking_by_subdomain';

      return RestResource.request(
        'get',
        url,
        { sub: subdomain },
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function getTotalPax(adults, children, infants, seniors, option) {
      var labelAdults = adults > 1 ? $translate('ADULTS') : $translate('ADULT');
      var titleAdults =
        option === 'short' ? '<span title="' + labelAdults + '">(A)</span>' : ' ' + labelAdults;
      var totalPax = adults + titleAdults;

      if (children) {
        var labelChildren = children > 1 ? $translate('CHILDREN') : $translate('CHILD');
        var titleChildren =
          option === 'short'
            ? '<span title="' + labelChildren + '">(C)</span>'
            : ' ' + labelChildren;
        totalPax = totalPax + ', ' + children + titleChildren;
      }

      if (infants) {
        var labelInfants = infants > 1 ? $translate('INFANTS') : $translate('INFANT');
        var titleInfants =
          option === 'short' ? '<span title="' + labelInfants + '">(I)</span>' : ' ' + labelInfants;
        totalPax = totalPax + ', ' + infants + titleInfants;
      }

      if (seniors) {
        var labelSeniors = seniors > 1 ? $translate('SENIORS') : $translate('SENIOR');
        var titleSeniors =
          option === 'short' ? '<span title="' + labelSeniors + '">(S)</span>' : ' ' + labelSeniors;
        totalPax = totalPax + ', ' + seniors + titleSeniors;
      }

      return totalPax;
    }

    function createBookingInvoice(bookingId, successCallback) {
      let modalParams = {
        title: 'CREATE_INVOICE',
        body: 'CREATE_INVOICE_FROM_BOOKING_DESC',
      };

      let confirmCallback = function () {
        let url = apiUrl + '/' + bookingId + '/create_booking_invoice';

        return RestResource.request(
          'post',
          url,
          {},
          function (response) {
            return successCallback(response.data);
          },
          function () {
            utils._errorMsg($translate('PROBLEMS_CREATING_THE_INVOICE'));

            return false;
          }
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    function deleteBooking(booking, successCallback) {
      let url = apiUrl + '/' + booking.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_BOOKING',
            itemName: booking.booking_number,
            body: 'DELETING_BOOKING_WARNING',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'BOOKING_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeBookingPriceList(bookingId, priceListId, successCallback, cancelCallback) {
      const modalParams = {
        title: 'CHANGE_PRICE_LIST_FOR_CURRENT_BOOKING',
        body: 'CHANGE_PRICE_LIST_FOR_CURRENT_BOOKING_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      const confirmCallback = function () {
        const url = apiUrl + '/' + bookingId + '/change_booking_price_list';

        const params = {
          skip_check_role: true,
          price_list_id: priceListId,
        };

        return RestResource.request(
          'put',
          url,
          params,
          function (response) {
            return successCallback(response.data);
          },
          function (response) {
            utils._errorMsg(response.data.error);
            return false;
          }
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);
    }

    function openSearchRelatedBookings(bill, billProduct, provider, successCallback) {
      BookingModalService.openSearchRelatedBookings(bill, billProduct, provider, successCallback);
    }

    function openRelatedTransactions(transaction, client) {
      let templateUrl = './app/ajs/bookings/modals/booking-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          clientId: client.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function hasRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/has_related_transactions/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function applyDiscountCoupon(bookingId, discountCouponId, successCallback, errorCallback) {
      let url = apiUrl + '/' + bookingId + '/apply_discount_coupon';

      const params = {
        skip_check_role: true,
        discount_coupon_id: discountCouponId,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function (response) {
          utils._successMsg($translate('DISCOUNT_COUPON_APPLIED'));

          return successCallback(response.data);
        },
        function () {
          return errorCallback();
        }
      );
    }

    function deleteDiscountCoupon(
      bookingId,
      successCallback,
      deleteDiscountCouponFromCurrencyChange
    ) {
      const confirmCallback = function () {
        const url = apiUrl + '/' + bookingId + '/delete_discount_coupon';

        const params = {
          skip_check_role: true,
        };

        return RestResource.request(
          'put',
          url,
          params,
          function (response) {
            if (!deleteDiscountCouponFromCurrencyChange) {
              utils._successMsg($translate('DISCOUNT_COUPON_DELETED'));
            }

            return successCallback(response.data);
          },
          function (response) {
            utils._errorMsg(response.data.error);
          }
        );
      };

      if (!deleteDiscountCouponFromCurrencyChange) {
        const modalParams = {
          title: 'DELETE_DISCOUNT_COUPON',
          body: 'DELETE_BOOKING_DISCOUNT_COUPON_MSG',
        };

        ModalWindowConfirmService.open(modalParams, confirmCallback);
      } else {
        confirmCallback();
      }
    }

    function openBookingInfoModal(bookingId) {
      // Use this if we wand to show the modal and preload the content first
      // BookingModalService.openBookingInfoModal(bookingId);

      getBooking(bookingId).then(function (data) {
        let templateUrl = './app/ajs/bookings/modals/booking-info-modal.html';

        let modalParams = {
          title: 'BOOKING_REPORT_VIEW',
          item: data,
        };

        WindowModalService.open(templateUrl, modalParams);
      });
    }
  }
})();
